module.exports = __webpack_public_path__ + "static/media/play-store.86428b05.svg";